import React from "react";
import { Link } from "react-router-dom";

import { Container, Navbar } from "react-bootstrap";

import { Headline } from "../Headline/Headline";
import { Logo } from "../Icons/Logo";

export const Navigation: React.FC = () => {
  return (
    <div className="navigation">
      <Container>
        <Navbar expand="lg">
          <div className="navigation__container">
            <Navbar.Brand as={Link} to="/">
              <Headline
                level="h1"
                bold="Meine Uniklinik"
                normal="Ihr digitaler Begleiter rund um den Klinikbesuch"
                reverse
              />
            </Navbar.Brand>
          </div>
          <Link className="logo" to="/">
            <Logo />
          </Link>
        </Navbar>
      </Container>
    </div>
  );
};
